export const Text = {
  color: 'text-color',
  variants: {
    textMuted: {
      color: 'neutral.600',
    },
    danger: {
      color: 'red.600',
    },
    error: {
      color: 'red.500',
    },
    warning: {
      color: 'yellow.500',
    },
    calcError: {
      _notLast: {
        borderBottom: '1px solid',
        borderBottomColor: 'gray.200',
      },
      p: 2,
      pb: 1,
    },
  },
}
